import React, { Component } from 'react';
import {Regex} from '../../util';
import Color from './Color';


class SmallCard extends Component {

  constructor(props){
    super(props);
    
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick() {
    const info = Object.assign({}, this.props);
    delete info.onClick;
    this.props.onClick(info);
  }

  render() {

    const {
      epgid,
      start,
      stop,
      duration,
      chname,
      title,
      desc,
      descStr,
      category,
      director,
      actor,
      rating,
      price,
      thumbnail,
      active,

      color,
      onDobbleClick
    } = this.props;

    
    const contentStyle = {
      backgroundColor: color,
      border: `1px solid ${ Color.darken(color, 60)}`
    };
    const height = 3*duration; // NOTE: 1분에 3px;
    const hourCell = 3 * 60 + 4; // NOTE: Timetable에서 1시간에 해당하는 셀의 높이


    const cardStyle = {
      height: `${height}px`,
      top: `${hourCell*(start.minutes()/60) + start.hours()*hourCell}px`
    };
    const clamp = Math.floor((height-12) / 18);
    const descEllipsis = {
      maxHeight: `${clamp*18}px`,
      WebkitLineClamp: clamp
    };
    const memoStr = desc ? desc.split('\n').map((item, index) => [item,  <br key={'bigCardindex'+index}/>]) : null;
    // const replaceDescStr = descStr ? descStr.split('\n').map((item, index) => [item, <br key={'bigCardindex'+index}/>]) : null;

    const tooltipText = `방송시작: ${start.format("MM/DD HH:mm")}
    방송종료: ${stop.format("MM/DD HH:mm")}`;

    const contentClasses = 'content ' + (active ? ' active' : '');

    return (
      <div className='card small' style={cardStyle} >
        <div className='time'>{start.minutes()}</div>
        <div className={contentClasses} style={contentStyle} data-tip={tooltipText} tabIndex={0} onDoubleClick={onDobbleClick}>
          <div className='description' style={descEllipsis}>
            {title}
            <div className='memo'>{category}</div>
            <div className='memo'>{price &&  Regex.getPriceComma(price)}</div>
            <div className='memo'>{director}</div>
            <div className='memo'>{memoStr}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default SmallCard;


// WEBPACK FOOTER //
// ./src/components/card/SmallCard.js